// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filteredDataTable_filteredTable__1YEG3 {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  text-align: center;\n  /* height: 100%; */\n}\n.filteredDataTable_filteredTable__1YEG3 footer {\n  margin: 32px 0;\n  align-self: flex-start;\n  text-align: left;\n}\n\n.filteredDataTable_rangePicker__3zKHK {\n  margin-bottom: 1rem;\n}\n.filteredDataTable_rangePicker__3zKHK h3 {\n  display: inline-block;\n  font-size: 1rem;\n  text-transform: capitalize;\n  margin: 0;\n  margin-right: 1rem;\n  font-weight: normal;\n}", ""]);
// Exports
exports.locals = {
	"filteredTable": "filteredDataTable_filteredTable__1YEG3",
	"rangePicker": "filteredDataTable_rangePicker__3zKHK"
};
module.exports = exports;
